import { DashboardErrorScreen } from '@/components/Error';
import {
    CampaignPlanner,
    campaignPlannerSearchSchema,
} from '@/dashboards/CampaignPlanner';
import { CampaignPlannerRouteProvider } from '@/dashboards/CampaignPlanner/providers';
import {
    FEATURE_FLAG_ACTIONS,
    FEATURE_FLAG_SUBJECTS,
    withAuthorization,
} from '@/features/Casl';
import { createFileRoute } from '@tanstack/react-router';

const CampaignOptimizationRouteComponent = () => {
    return (
        <CampaignPlannerRouteProvider routeId={Route.id}>
            <CampaignPlanner />
        </CampaignPlannerRouteProvider>
    );
};

export const Route = createFileRoute(
    '/_org/project/$projectId/_dashboards/campaign-planner',
)({
    component: withAuthorization(
        CampaignOptimizationRouteComponent,
        FEATURE_FLAG_ACTIONS.VIEW,
        FEATURE_FLAG_SUBJECTS.CAMPAIGN_OPTIMIZATION_DASHBOARD,
    ),
    validateSearch: campaignPlannerSearchSchema,
    errorComponent: DashboardErrorScreen,
});
